import { FunctionComponent } from 'react';
import { Box, FormControl, TextField, Theme } from '@mui/material';
import { IConnectorCredentialsFormProps } from '../connectors-types';
import TokenVerifiedTextFieldAndorment from './TokenVerifiedTextFieldAndorment';
import { makeStyles } from 'tss-react/mui';

const ClientIdSecretKeyForm: FunctionComponent<
  React.PropsWithChildren<IConnectorCredentialsFormProps>
> = props => {
  const {
    values,
    handleOnChange,
    isConnectorConfigured,
    errorMessage,
    areCredentialsExpired,
  } = props;

  const { classes } = useStyles();

  return (
    <Box display='flex' flexDirection='column' gap={2} alignItems='flex-start'>
      <FormControl className={classes.fullWidth}>
        <TextField
          autoComplete='off'
          size='small'
          required
          type='text'
          variant='outlined'
          label='AWS Access Key ID'
          name='clientId'
          value={values.clientId}
          onChange={handleOnChange}
          fullWidth
          disabled={isConnectorConfigured}
          error={!!errorMessage}
          InputProps={{
            endAdornment: (
              <TokenVerifiedTextFieldAndorment
                isConnectorValid={areCredentialsExpired}
                isConnectorConfigured={isConnectorConfigured}
              />
            ),
          }}
        />
      </FormControl>
      <FormControl className={classes.fullWidth}>
        <TextField
          autoComplete='off'
          size='small'
          required
          type='text'
          variant='outlined'
          label='AWS Secret Access Key'
          name='secretKey'
          fullWidth
          value={values.secretKey}
          onChange={handleOnChange}
          disabled={isConnectorConfigured}
          error={!!errorMessage}
          helperText={errorMessage}
          InputProps={{
            endAdornment: (
              <TokenVerifiedTextFieldAndorment
                isConnectorValid={areCredentialsExpired}
                isConnectorConfigured={isConnectorConfigured}
              />
            ),
          }}
        />
      </FormControl>
    </Box>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  fullWidth: {
    width: '100%',
  },
}));

export default ClientIdSecretKeyForm;
